import styled from "styled-components";

export const StyledList = styled.ul`
  display: flex;
  align-items: center;
  gap: 24px;
`;
